<template>
  <!-- {{ Paymentlist }} -->
  <b-container>
    <b-row class="py-4">
      <b-col
        lg="3"
        md="3"
        sm="6"
        cols="12"
        v-for="(item, index) in Paymentlist"
        :key="index"
        class="mb-3"
      >
        <div class="quickcreatecard text-center shadow-sm">
          <div class="card-body p-2">
            <p class="stat-label">
              {{ item["title"] }}
            </p>
            <h6 class="stat-value">
              {{ item["count"] }}
            </h6>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
// import { useToast } from "primevue/usetoast";
// import router from "@/router";
import POPaymentTermsService from "../../../../modules/Inventory/Service/POPaymentTermsDetails";
import { useRouter, useRoute } from "vue-router";
// import LiveCallService from "../../../../modules/crm/service/liveCallsService";
// import LeadsService from "../../../../modules/crm/service/leadService";
// import ContactService from "../../../../modules/crm/service/contactService";
// import SiteVisitService from "../../../../modules/crm/service/siteVisitService";
// import { object } from "yup";
// import AssignTo from "../../../../modules/crm/pages/contact/assignTo.vue";
// import { value } from "dom7";
// import Contactservice from "../../../../modules/crm/service/contactService";
// import MastersService from "../../../../modules/crm/service/MastersService";
// import crmDashboardSkeleton from "../../../../components/SkeletonLoaderComponents/crmDashboardSkeleton.vue";
// import EntityMasterservice from "../../../../modules/crm/service/EntityMasterService"

export default defineComponent({
  //   components: {
  //   },

  setup() {
    //Declarations
    const routes = useRoute();
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let HospitalId = Number(usersData.OrganizationId);
    let BranchId = Number(usersData.BranchId);

    const ParamValues = ref({
      StoreId: Number(routes.query.Id ?? 0),
    });

    let Paymentlist = ref([]);

    onMounted(() => {
      debugger;
      ReadyFunction();
    });

    async function ReadyFunction() {
      debugger;

      await IsPaymentList();
    }

    const IsPaymentList = async () => {
      debugger;
      try {
        debugger;

        const response = await POPaymentTermsService.GetPaymentDashboard(
          ParamValues.value.StoreId,
          BranchId,
          usersData.OrganizationId
        );

        console.log(response);
        Paymentlist.value = response["result"];
      } catch (error) {
        // alert(error);
      }
    };

    const bgcolor = (data) => {
      return {
        backgroundColor: data,
        padding: "20px 10px 10px 10px",
        margin: "10px 0",
      };
    };

    return {
      Paymentlist,
      bgcolor,
    };
  },
});
</script>

<style lang="scss" scoped>
.details-count-cards {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 120px;
}

.details-count-cards:hover {
  box-shadow: 0 4px 8px 0 #999999;
  cursor: pointer;
}

.details-count-cards p {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
}

.details-count-cards h3 {
  text-align: center;
  font-size: 24px;
  color: #444;
  font-weight: bolder;
}

@media only screen and (max-width: 545px) {
  .details-count-cards p {
    font-size: 13px;
  }
}

// .details-bg :nth-child(odd):not(.details-count-cards) {
//     background-color: yellow;
// }

// .details-bg :nth-child(even):not(.details-count-cards) {
//     background-color: orange;
// }
.compo-heading {
  margin-bottom: -5px;
}
</style>

<style lang="scss">
.callstab .p-tabview-panels {
  background-color: #f8f9fe !important;
}

.callstab .p-badge {
  font-size: 0.6rem;
  min-width: 1.3rem;
  height: 1.3rem;
  line-height: 1.3rem;
  margin-left: 5px !important;
}

.quickcreatecard {
  padding: 10px;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  margin: 10px 0px;
  height: 110px;
}
</style>
